import { render } from "./EmailProcessor.vue?vue&type=template&id=40406caa"
import script from "./EmailProcessor.vue?vue&type=script&lang=js"
export * from "./EmailProcessor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__